<template>
    <div class="container">
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220616/1655350097599.jpg" alt="">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220616/1655347145550.jpg" alt="">
            <div class="coupon-btn" @click="goReceviceCoupon"></div>
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220616/1655347167556.jpg" alt="">
            <div class="section-btn" @click="goHerfFn(0)"></div>
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220616/1655347180050.jpg" alt="">
            <div class="section-btn" @click="goHerfFn(1)"></div>
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220616/1655347200785.jpg" alt="">
            <div class="section-btn section-btn-2" @click="goHerfFn(2)"></div>
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220616/1655347214650.jpg" alt="">
            <div class="section-btn section-btn-2" @click="goHerfFn(3)"></div>
        </div>
        <div class="footer" @click="goReceviceCoupon">
            <img src="https://s21.lgstatic.com/growth/activity/20220616/1655347228377.jpg" alt="">
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
export default {
    data() {
        return {
            urls: [
                'https://activity.lagou.com/app/toc/resume-refinement.html?sellId=852',
                'https://activity.lagou.com/app/toc/interview-coach.html?sellId=1026',
                'https://activity.lagou.com/app/toc/career-counseling.html',
                'https://edu.lagou.com/growth/sem/offer.html'
            ]
        }
    },
    created () {

    },
    methods: {
        goReceviceCoupon() {
            this.goHref("https://activity.lagou.com/app/toc/voucher-collection-center.html?url=https://activity.lagou.com/app/toc/resume-refinement.html?sellId=852&utm_source=coupon1&or=342_343_344", 1);
        },
        goHerfFn(index) {
            this.goHref(this.urls[index], index == 3 ? 0 : 1);
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 184px;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 100%;
    }
}
.coupon-btn {
    position: absolute;
    left: 280px;
    top: 70px;
    width: 240px;
    height: 60px;
}
.section-btn {
    position: absolute;
    left: 50%;
    bottom: 60px;
    transform: translateX(-50%);
    width: 320px;
    height: 76px;
    &-2 {
        bottom: 45px;
    }
}
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 184px;
    img {
        width: 100%;
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 600px;
        height: 555px;
        background-color: #FF8315;
        border-radius: 12px;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 324px;
            height: 87px;
            margin: 92px auto 0;
        }
        .subject-list {
            display: flex;
            width: 560px;
            height: 212px;
            padding-top: 42px;
            margin: 47px auto 0;
            box-sizing: border-box;
            background-color: #F17100;
            border-radius: 4px;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 113px;
                height: 54px;
                line-height: 54px;
                padding: 0 14px;
                box-sizing: border-box;
                font-size: 26px;
                color: #fff;
                text-align: center;
                margin-bottom: 27px;
                margin-right: 20px;
                background-color: #FFA85B;
                border-radius: 3px;
                &:nth-child(4n) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #A95000;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFDDBF 100%);
        font-size: 36px;
        font-weight: bold;
        color: #E96D00;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -140px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
}
</style>
